import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountRelation  {
    _originalTypeClassName = "zERP.BO.AccountRelation";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountRelation.translate = translateService;
}
this.AccountRelationDetails = [];
this.AccountRelationType = new Domain.AccountRelationType();
this.Journal = new Domain.AccountingJournal();
this.AccountRelationID = null;
this._key = this.AccountRelationID = 0; 
}

static translate: TranslateService;
_key: any;
private _AccountRelationID:any;
get AccountRelationID(): any {
    return this._AccountRelationID;
  }
set AccountRelationID(value: any) {
    this._AccountRelationID = value;
    this._key = value;
  }
AccountRelationDetails:any;
Account:any;
AccountRelationType:any;
Ledger:any;
Journal:any;
AccountingEvent:any;
static setAccountRelationDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.AccountRelationDetails == null) $this.AccountRelationDetails = [];

                const copyItems = Common.cloneObject(items);

                while ($this.AccountRelationDetails.length > 0) {
                    Domain.AccountRelation.removeAccountRelationDetails($this, $this.AccountRelationDetails[0]);
                }

                Domain.AccountRelation.addManyAccountRelationDetails($this, copyItems);
            }
static addManyAccountRelationDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountRelation.addAccountRelationDetails($this, items[i]);
                }
            }
static addAccountRelationDetails = ($this, item) => {
                if ($this.AccountRelationDetails == null) $this.AccountRelationDetails = [];
                if (item == null || $this.AccountRelationDetails.indexOf(item) > -1) return;
                $this.AccountRelationDetails.push(item);
}
static addRangeAccountRelationDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountRelation.addAccountRelationDetails($this, item));
            }
static removeAccountRelationDetails = ($this, item) => {
                if ($this == null || $this.AccountRelationDetails == null || $this.AccountRelationDetails.indexOf(item) === -1) return;
                var _index = $this.AccountRelationDetails.indexOf(item);
                $this.AccountRelationDetails.splice(_index, 1);
}
static clearAccountRelationDetails = ($this) => { $this.AccountRelationDetails = null; }
static setAccount = ($this, value) => {
var oldValue = $this.Account;
$this.Account = value;
if (value != null) {
}
}
static setAccountRelationType = ($this, value) => {
var oldValue = $this.AccountRelationType;
$this.AccountRelationType = value;
if (value != null) {
}
}
static setLedger = ($this, value) => {
var oldValue = $this.Ledger;
$this.Ledger = value;
if (value != null) {
}
}
static setJournal = ($this, value) => {
var oldValue = $this.Journal;
$this.Journal = value;
if (value != null) {
}
}
static setAccountingEvent = ($this, value) => {
var oldValue = $this.AccountingEvent;
$this.AccountingEvent = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AccountRelationID == null || $this.AccountRelationID == 0;
            }


}